// Login.tsx
import React, { useEffect, useRef  } from 'react';
import LoginForm from "../Components/loginForm";
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../Css/home.css'
import { Helmet } from 'react-helmet-async';

const Login: React.FC = () => {

    const [params] = useSearchParams();
    const shownRef = useRef(false);

  useEffect(() => {
    if (shownRef.current) return;

    if (params.get('success')) {
      toast.success('🎉 Abonnement activé avec succès !');
      shownRef.current = true;
    }
  }, [params]);

    return (
      <>
        <Helmet>
          <title>
            Login | Stockifly
          </title>

          <meta
            name="description"
            content="Login to Stockifly"
          />
        </Helmet>

        <div className="column-home-right">
          <LoginForm />
        </div>
      </>
    )
};

export default Login;
